import { Synchronized } from '#common/util';
import { parseWasmResult } from '#wasm/common';
export class SnapshotSchedulerWasm extends Synchronized {
    mod;
    constructor(mod, mutex) {
        super(mutex);
        this.mod = mod;
    }
    async createSchedule(createInfo) {
        return await this.mutex.runExclusive(async () => {
            return parseWasmResult(await this.mod.CreateSchedule(createInfo));
        });
    }
    async deleteSchedule(label) {
        return await this.mutex.runExclusive(async () => {
            parseWasmResult(await this.mod.DeleteSchedule(label));
        });
    }
    async listSchedules() {
        return await this.mutex.runExclusive(async () => {
            return parseWasmResult(await this.mod.ListSchedules());
        });
    }
}
